export default {
  adsBanner: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  aawzFeed: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  externalLinks: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
